import { ICarouseltoppagesItem, IpaginatedCarouseltoppages } from '../models'

export enum CarouseltoppagesActionTypes {
  SEARCH_CAROUSELTOPPAGES = 'carouseltoppages/search',
  SEARCHING_CAROUSELTOPPAGES = 'carouseltoppages/searching',
  FOUND_CAROUSELTOPPAGES = 'carouseltoppages/found',
  SEARCHING_CAROUSELTOPPAGES_FAILED = 'carouseltoppages/searching_failed',

  LOAD_CAROUSELTOPPAGES = 'carouseltoppages/load',
  LOADING_CAROUSELTOPPAGES = 'carouseltoppages/loading',
  LOADED_CAROUSELTOPPAGES = 'carouseltoppages/loaded',
  LOADING_CAROUSELTOPPAGES_FAILED = 'carouseltoppages/loading_failed',

  ADD_CAROUSELTOPPAGES = 'carouseltoppages/add',
  ADDING_CAROUSELTOPPAGES = 'carouseltoppages/adding',
  ADDED_CAROUSELTOPPAGES = 'carouseltoppages/added',
  ADDING_CAROUSELTOPPAGES_FAILED = 'carouseltoppages/adding_failed',

  REMOVE_CAROUSELTOPPAGE = 'carouseltoppages/remove',
  REMOVING_CAROUSELTOPPAGE = 'carouseltoppages/removing',
  REMOVED_CAROUSELTOPPAGE = 'carouseltoppages/removed',
  REMOVING_CAROUSELTOPPAGE_FAILED = 'carouseltoppages/removing_failed',

  SOFT_REMOVE_CAROUSELTOPPAGES = 'carouseltoppages/soft_remove',
  SOFT_REMOVING_CAROUSELTOPPAGES = 'carouseltoppages/soft_removing',
  SOFT_REMOVED_CAROUSELTOPPAGES = 'carouseltoppages/soft_removed',
  SOFT_REMOVING_CAROUSELTOPPAGES_FAILED = 'carouseltoppages/soft_removing_failed',

  EDIT_CAROUSELTOPPAGES = 'carouseltoppages/edit',
  EDITING_CAROUSELTOPPAGES = 'carouseltoppages/editing',
  EDITED_CAROUSELTOPPAGES = 'carouseltoppages/edited',
  EDITING_CAROUSELTOPPAGES_FAILED = 'carouseltoppages/editing_failed',

  VIEW_CAROUSELTOPPAGES = 'carouseltoppages/view',
  VIEWING_CAROUSELTOPPAGES = 'carouseltoppages/viewing',
  VIEWED_CAROUSELTOPPAGES = 'carouseltoppages/viewed',
  VIEWING_CAROUSELTOPPAGES_FAILED = 'carouseltoppages/viewing_failed',
}

export function searchCarouseltoppages(searchOptions: TSearchOptions | string, keep?: boolean): ISearchCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.SEARCH_CAROUSELTOPPAGES,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingCarouseltoppages(): ISearchingCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.SEARCHING_CAROUSELTOPPAGES,
  }
}

export function foundCarouseltoppages(carouseltoppages: IpaginatedCarouseltoppages, keep?: boolean): IFoundCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.FOUND_CAROUSELTOPPAGES,
    keep: keep,
    payload: {
      carouseltoppages,
    },
  }
}

export function searchingCarouseltoppagesFailed(): ISearchingCarouseltoppagesFailedAction {
  return {
    type: CarouseltoppagesActionTypes.SEARCHING_CAROUSELTOPPAGES_FAILED,
  }
}

export function loadCarouseltoppages(loadOptions: TSearchOptions): ILoadCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.LOAD_CAROUSELTOPPAGES,
    loadOptions: loadOptions,
  }
}

export function loadingCarouseltoppages(): ILoadingCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.LOADING_CAROUSELTOPPAGES,
  }
}

export function loadedCarouseltoppages(carouseltoppages: IpaginatedCarouseltoppages): ILoadedCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.LOADED_CAROUSELTOPPAGES,
    payload: {
      carouseltoppages,
    },
  }
}

export function loadingCarouseltoppagesFailed(): ILoadingCarouseltoppagesFailedAction {
  return {
    type: CarouseltoppagesActionTypes.LOADING_CAROUSELTOPPAGES_FAILED,
  }
}

export function addCarouseltoppages(carouseltoppage: ICarouseltoppagesItem): IAddCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.ADD_CAROUSELTOPPAGES,
    payload: carouseltoppage,
  }
}

export function addingCarouseltoppages(): IAddingCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.ADDING_CAROUSELTOPPAGES,
  }
}

export function addedCarouseltoppages(carouseltoppages: IpaginatedCarouseltoppages): IAddedCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.ADDED_CAROUSELTOPPAGES,
    payload: {
      carouseltoppages,
    },
  }
}

export function addingCarouseltoppagesFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingCarouseltoppagesFailedAction {
  return {
    type: CarouseltoppagesActionTypes.ADDING_CAROUSELTOPPAGES_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeCarouseltoppage(carouseltoppage: ICarouseltoppagesItem): IRemoveCarouseltoppageAction {
  return {
    type: CarouseltoppagesActionTypes.REMOVE_CAROUSELTOPPAGE,
    payload: carouseltoppage,
  }
}

export function removingCarouseltoppage(): IRemovingCarouseltoppageAction {
  return {
    type: CarouseltoppagesActionTypes.REMOVING_CAROUSELTOPPAGE,
  }
}

export function removedCarouseltoppage(): IRemovedCarouseltoppageAction {
  return {
    type: CarouseltoppagesActionTypes.REMOVED_CAROUSELTOPPAGE,
  }
}

export function removingCarouseltoppageFailed(): IRemovingCarouseltoppageFailedAction {
  return {
    type: CarouseltoppagesActionTypes.REMOVING_CAROUSELTOPPAGE_FAILED,
  }
}

export function softRemoveCarouseltoppages(carouseltoppage: ICarouseltoppagesItem): ISoftRemoveCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.SOFT_REMOVE_CAROUSELTOPPAGES,
    payload: carouseltoppage,
  }
}

export function softRemovingCarouseltoppages(): ISoftRemovingCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.SOFT_REMOVING_CAROUSELTOPPAGES,
  }
}

export function softRemovedCarouseltoppages(carouseltoppage: ICarouseltoppagesItem): ISoftRemovedCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.SOFT_REMOVED_CAROUSELTOPPAGES,
    payload: carouseltoppage,
  }
}

export function softRemovingCarouseltoppagesFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingCarouseltoppagesFailedAction {
  return {
    type: CarouseltoppagesActionTypes.SOFT_REMOVING_CAROUSELTOPPAGES_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editCarouseltoppages(carouseltoppage: ICarouseltoppagesItem): IEditCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.EDIT_CAROUSELTOPPAGES,
    payload: carouseltoppage,
  }
}

export function editingCarouseltoppages(): IEditingCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.EDITING_CAROUSELTOPPAGES,
  }
}

export function editedCarouseltoppages(carouseltoppages: ICarouseltoppagesItem): IEditedCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.EDITED_CAROUSELTOPPAGES,
    payload: carouseltoppages,
  }
}

export function editingCarouseltoppagesFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingCarouseltoppagesFailedAction {
  return {
    type: CarouseltoppagesActionTypes.EDITING_CAROUSELTOPPAGES_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewCarouseltoppages(carouseltoppage: ICarouseltoppagesItem): IViewCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.VIEW_CAROUSELTOPPAGES,
    payload: carouseltoppage,
  }
}

export function viewingCarouseltoppages(): IViewingCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.VIEWING_CAROUSELTOPPAGES,
  }
}

export function viewedCarouseltoppages(carouseltoppages: ICarouseltoppagesItem): IViewedCarouseltoppagesAction {
  return {
    type: CarouseltoppagesActionTypes.VIEWED_CAROUSELTOPPAGES,
    payload: carouseltoppages,
  }
}

export function viewingCarouseltoppagesFailed(): IViewingCarouseltoppagesFailedAction {
  return {
    type: CarouseltoppagesActionTypes.VIEWING_CAROUSELTOPPAGES_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.SEARCH_CAROUSELTOPPAGES
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.SEARCHING_CAROUSELTOPPAGES
}

export interface IFoundCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.FOUND_CAROUSELTOPPAGES
  keep?: boolean
  payload: {
    carouseltoppages: IpaginatedCarouseltoppages
  }
}

export interface ISearchingCarouseltoppagesFailedAction {
  type: CarouseltoppagesActionTypes.SEARCHING_CAROUSELTOPPAGES_FAILED
}

export interface ILoadCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.LOAD_CAROUSELTOPPAGES
  loadOptions: TSearchOptions
}

export interface ILoadingCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.LOADING_CAROUSELTOPPAGES
}

export interface ILoadedCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.LOADED_CAROUSELTOPPAGES
  payload: {
    carouseltoppages: IpaginatedCarouseltoppages
  }
}

export interface ILoadingCarouseltoppagesFailedAction {
  type: CarouseltoppagesActionTypes.LOADING_CAROUSELTOPPAGES_FAILED
}

export interface IAddCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.ADD_CAROUSELTOPPAGES
  payload: ICarouseltoppagesItem
}

export interface IAddingCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.ADDING_CAROUSELTOPPAGES
}

export interface IAddedCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.ADDED_CAROUSELTOPPAGES
  payload: {
    carouseltoppages: IpaginatedCarouseltoppages
  }
}

export interface IAddingCarouseltoppagesFailedAction {
  type: CarouseltoppagesActionTypes.ADDING_CAROUSELTOPPAGES_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveCarouseltoppageAction {
  type: CarouseltoppagesActionTypes.REMOVE_CAROUSELTOPPAGE
  payload: ICarouseltoppagesItem
}

export interface IRemovingCarouseltoppageAction {
  type: CarouseltoppagesActionTypes.REMOVING_CAROUSELTOPPAGE
}

export interface IRemovedCarouseltoppageAction {
  type: CarouseltoppagesActionTypes.REMOVED_CAROUSELTOPPAGE
}

export interface IRemovingCarouseltoppageFailedAction {
  type: CarouseltoppagesActionTypes.REMOVING_CAROUSELTOPPAGE_FAILED
}

export interface ISoftRemoveCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.SOFT_REMOVE_CAROUSELTOPPAGES
  payload: ICarouseltoppagesItem
}

export interface ISoftRemovingCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.SOFT_REMOVING_CAROUSELTOPPAGES
}

export interface ISoftRemovedCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.SOFT_REMOVED_CAROUSELTOPPAGES
  payload: ICarouseltoppagesItem
}

export interface ISoftRemovingCarouseltoppagesFailedAction {
  type: CarouseltoppagesActionTypes.SOFT_REMOVING_CAROUSELTOPPAGES_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.EDIT_CAROUSELTOPPAGES
  payload: ICarouseltoppagesItem
}

export interface IEditingCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.EDITING_CAROUSELTOPPAGES
}

export interface IEditedCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.EDITED_CAROUSELTOPPAGES
  payload: ICarouseltoppagesItem
}

export interface IEditingCarouseltoppagesFailedAction {
  type: CarouseltoppagesActionTypes.EDITING_CAROUSELTOPPAGES_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.VIEW_CAROUSELTOPPAGES
  payload: ICarouseltoppagesItem
}

export interface IViewingCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.VIEWING_CAROUSELTOPPAGES
}

export interface IViewedCarouseltoppagesAction {
  type: CarouseltoppagesActionTypes.VIEWED_CAROUSELTOPPAGES
  payload: ICarouseltoppagesItem
}

export interface IViewingCarouseltoppagesFailedAction {
  type: CarouseltoppagesActionTypes.VIEWING_CAROUSELTOPPAGES_FAILED
}

export type CarouseltoppagesAction =
  | ISearchCarouseltoppagesAction
  | ISearchingCarouseltoppagesAction
  | IFoundCarouseltoppagesAction
  | ISearchingCarouseltoppagesFailedAction
  | ILoadCarouseltoppagesAction
  | ILoadingCarouseltoppagesAction
  | ILoadedCarouseltoppagesAction
  | ILoadingCarouseltoppagesFailedAction
  | IAddCarouseltoppagesAction
  | IAddingCarouseltoppagesAction
  | IAddedCarouseltoppagesAction
  | IAddingCarouseltoppagesFailedAction
  | IRemoveCarouseltoppageAction
  | IRemovingCarouseltoppageAction
  | IRemovedCarouseltoppageAction
  | IRemovingCarouseltoppageFailedAction
  | ISoftRemoveCarouseltoppagesAction
  | ISoftRemovingCarouseltoppagesAction
  | ISoftRemovedCarouseltoppagesAction
  | ISoftRemovingCarouseltoppagesFailedAction
  | IEditCarouseltoppagesAction
  | IEditingCarouseltoppagesAction
  | IEditedCarouseltoppagesAction
  | IEditingCarouseltoppagesFailedAction
  | IViewCarouseltoppagesAction
  | IViewingCarouseltoppagesAction
  | IViewedCarouseltoppagesAction
  | IViewingCarouseltoppagesFailedAction
